module.exports = __webpack_public_path__ + "img/althiqua-logo.e6b1d4db.svg";